import React, { Component } from "react";
import { connect } from "react-redux";

import { createAvailableGateway } from "actions/availableGateway";
import {
  uploadImage,
  setUploadedImagePreview,
  removeUploadedImage
} from "actions/image";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/AvailableGateway/Form";

class AvailableGatewayCreate extends Component {
  componentDidMount() {
    const { fetchRateLimits } = this.props;
  }

  handleFormSubmit = data => {
    this.createAvailableGateway(data);
  };

  createAvailableGateway(data) {
    const {
      toggleNotification,
      toggleFullPageSpinner,
      createAvailableGateway,
      removeUploadedImage,
      uploadedImages,
      uploadedImagesPreview,
      uploadedImagesPercentage,
      setUploadedImagePreview,
      history
    } = this.props;
    toggleFullPageSpinner(true);
    createAvailableGateway(data)
      .then(() => {
        toggleNotification(true, {
          message: "Created AvailableGateway Success",
          infoClassName: "is-success"
        });
        history.push(`/available-gateways`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    const {
      uploadImage,
      removeUploadedImage,
      uploadedImages,
      uploadedImagesPreview,
      uploadedImagesPercentage,
      setUploadedImagePreview
    } = this.props;

    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        uploadImage={uploadImage}
        uploadedImages={uploadedImages}
        setUploadedImagePreview={setUploadedImagePreview}
        removeUploadedImage={removeUploadedImage}
        uploadedImagesPreview={uploadedImagesPreview}
        uploadedImagesPercentage={uploadedImagesPercentage}
      />
    );
  }
}

const mapStateToProps = ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview
}) => ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview
});

export default connect(mapStateToProps, {
  createAvailableGateway,
  toggleFullPageSpinner,
  toggleNotification,
  uploadImage,
  setUploadedImagePreview,
  removeUploadedImage,
  setUploadedImagePreview
})(AvailableGatewayCreate);



// WEBPACK FOOTER //
// ./src/pages/AvailableGateway/Create/index.js